import {vuepayAlert} from "../../util/utility";

let _intervalId, _localstream;


export const startVideoStream = (callback) => {
    const mediaConfig = {video: true, audio: false};
    const errBack = function (e) {
        callback(undefined)
        return
    };

    // Get access to the camera!
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia(mediaConfig).then(function (stream) {
            callback(stream);
        }, errBack);
    } else if (navigator.getUserMedia) { // Standard
        navigator.getUserMedia(mediaConfig, function (stream) {
            callback(stream);
        }, errBack);
    } else if (navigator.webkitGetUserMedia) { // WebKit-prefixed
        navigator.webkitGetUserMedia(mediaConfig, function (stream) {
            callback(window.webkitURL.createObjectURL(stream));
        }, errBack);
    } else if (navigator.mozGetUserMedia) { // Mozilla-prefixed
        navigator.mozGetUserMedia(mediaConfig, function (stream) {
            callback(window.URL.createObjectURL(stream));
        }, errBack);
    }
}

export const _startInterval = (countTillInSeconds, callback) => {

    let duration = countTillInSeconds;
    let durationUI = "";
    // Update the count down every 1 second
    let interval = 1000;

    _intervalId = setInterval(function () {

        //Otherwise
        duration = duration - 1;
        if (duration.toLocaleString().length === 1) {
            durationUI = "Countdown to go live: 00:0" + duration + " mins";
        } else {
            durationUI = "Countdown to go live: 00:" + duration + " mins";
        }

        // Time Out check
        callback(duration, durationUI);

    }, interval);
}

export const _clearInterval = () => {
    clearInterval(_intervalId);
}

export const requestFullScreen = (video) => {
    if (video.requestFullscreen) { // Other Browser
        video.requestFullscreen();
    } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen(); // Mozilla
    } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen(); // Chrome and Safari
    }
};

export const cancelFullScreen = (video) => {
    if (video.cancelFullscreen) {  // Other Browser
        video.cancelFullscreen();
    } else if (video.mozCancelFullScreen) {  // Mozilla
        video.mozCancelFullScreen();
    } else if (video.webkitCancelFullScreen) { // Webkit for video elements only
        video.webkitCancelFullScreen();
    }
};